import 'regenerator-runtime/runtime';
import { call, select } from 'redux-saga/effects';

import { getThreeState, handleGenericError } from '../common';
import { setRenderFlag } from './animationFrame';

export default function* addBrush(action) {
  try {
    const { scene } = yield select(getThreeState);
    if (!scene) return;
    const { brush, dot } = action.payload;
    scene.add(brush);
    scene.add(dot);
    setRenderFlag();
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
